<script setup>
import { format } from '@formkit/tempo'
import DelimiterSection from '@sections/delimiter-crosses.vue'
import { computed, onMounted, ref, watch } from 'vue'
import Markdown from 'vue3-markdown-it'
import { useRoute, useRouter } from 'vue-router'

import Loading from '@components/global/Loading.vue'
import Button from '@components/global/button.vue'

const route = useRoute()
const loading = ref(false)
const article = ref({})
const requestPage = ref(null)
const slug = computed(() => route.params.slug)

function cancelPage() {
	if (requestPage.value) requestPage.value.cancel()
}
function getPage() {
	loading.value = true
	article.value = {}
	cancelPage()
	let axiosSource = axios.CancelToken.source()
	requestPage.value = { cancel: axiosSource.cancel }
	axios
		.get(`/api/news/${route.params.slug}`, {
			cancelToken: axiosSource.token,
		})
		.then((a) => {
			loading.value = false
			article.value = a.data
		})
		.catch((e) => {})
}
getPage()

watch(slug, async () => {
	getPage()
})
</script>

<template>
	<Loading v-if="loading" />
	<template v-else>
		<div class="relative">
			<img class="max-h-[700px] w-full object-cover" :src="article.image" :alt="article.title" />
			<div class="vector vector-left">
				<img src="https://cdn.projectether.co/images/home-page/bot-left.svg" class="w-full" alt="" />
				<div class="absolute left-[-50%] top-[50%] h-[1px] w-[655px] origin-top-left bg-border-default" />
			</div>
		</div>
		<section class="container flex flex-col items-center gap-4 text-default lg:gap-12">
			<div class="flex flex-col gap-4 lg:w-[80%]">
				<div class="flex gap-2">
					<span class="label-small outlined w-fit">
						{{ format(article.published_at, 'full') }}
					</span>
					<span class="label-small inverse">{{ article.category.name }}</span>
				</div>
				<h4 class="animation uppercase">
					{{ article.title }}
				</h4>
			</div>

			<div class="h-[1px] w-full bg-border-default lg:w-[80%]" />

			<Markdown class="markdown article" :source="article.body" :breaks="true" />

			<DelimiterSection :rows="4" />
		</section>
	</template>
</template>

<style scoped>
.vector {
	@apply absolute hidden bg-no-repeat fill-bg lg:flex;
}

.vector-left {
	@apply bottom-0 left-0 z-images h-[60px] w-[500px];
}

.btn.outlined {
	@apply sticky left-12 top-[20%] hidden bg-bg bg-opacity-90 lg:flex;
}
</style>
